import { jwtDecode } from "jwt-decode";

const ROLE_CLAIM_KEYS = [
  "role",
  "roles",
  "http://schemas.microsoft.com/ws/2008/06/identity/claims/role",
];

const normalizeRoles = (value: unknown): string[] => {
  if (!value) return [];
  if (Array.isArray(value)) {
    return value.filter((role): role is string => typeof role === "string");
  }
  if (typeof value === "string") return [value];
  return [];
};

export const getJwtRoles = (): string[] => {
  const token = localStorage.getItem("jwt");
  if (!token) return [];

  try {
    const decoded = jwtDecode<Record<string, unknown>>(token);
    for (const key of ROLE_CLAIM_KEYS) {
      const roles = normalizeRoles(decoded[key]);
      if (roles.length > 0) return roles;
    }
    return [];
  } catch {
    return [];
  }
};

export const hasJwtRole = (roleName: string): boolean =>
  getJwtRoles().some(
    (role) => role.localeCompare(roleName, undefined, { sensitivity: "accent" }) === 0
  );
